import { SwitchToggleInput } from '@trufla-technology/trumarket-react-design-system/lib/components/controls/SwitchToggleInput';
import { TextInput } from '@trufla-technology/trumarket-react-design-system/lib/components/controls/TextInput';
import { FacebookIcon } from '@trufla-technology/trumarket-react-design-system/lib/components/icons/FacebookIcon';
import { LinkedinIcon } from '@trufla-technology/trumarket-react-design-system/lib/components/icons/LinkedinIcon';
import { TwitterIcon } from '@trufla-technology/trumarket-react-design-system/lib/components/icons/TwitterIcon';
import { YoutubeIcon } from '@trufla-technology/trumarket-react-design-system/lib/components/icons/YoutubeIcon';
import { FormHookResult } from '@trufla-technology/trumarket-react-design-system/lib/components/widgets/TruForm/hooks/useForm';
import { urlRule } from '@trufla-technology/trumarket-react-design-system/lib/utils/validation_rules';
import { BranchFormType } from 'app/types/Branch';

type propType = {
  changeValue: (key: string, value: boolean) => void;
  disabled: boolean;
  form: FormHookResult<BranchFormType>;
};
export const SocialMediaSection = ({
  changeValue,
  disabled,
  form,
}: propType) => {
  return (
    <>
      <p className="title">Social Media</p>
      <div className="inputs-wrraper">
        <div className="global-toggle">
          <span className="label">Use Global</span>
          <form.Item name="useGlobalSocialMedia">
            <SwitchToggleInput
              onChange={(v) => {
                changeValue('useGlobalSocialMedia', v);
              }}
            />
          </form.Item>
        </div>

        <div className="flex-50">
          <div className="socialmedia-input">
            <div className="icon">
              <FacebookIcon width="10px" />
            </div>
            <form.Item name="socialMedia.facebook" rules={[...urlRule]}>
              <TextInput disabled={disabled} />
            </form.Item>
          </div>
          <div className="socialmedia-input">
            <div className="icon">
              <TwitterIcon width="18px" />
            </div>
            <form.Item name="socialMedia.twitter" rules={[...urlRule]}>
              <TextInput disabled={disabled} />
            </form.Item>
          </div>
          <div className="socialmedia-input">
            <div className="icon">
              <LinkedinIcon width="18px" />
            </div>
            <form.Item name="socialMedia.linkedIn" rules={[...urlRule]}>
              <TextInput disabled={disabled} />
            </form.Item>
          </div>
          <div className="socialmedia-input">
            <div className="icon">
              <YoutubeIcon width="18px" />
            </div>
            <form.Item name="socialMedia.youtube" rules={[...urlRule]}>
              <TextInput disabled={disabled} />
            </form.Item>
          </div>
        </div>
      </div>
    </>
  );
};
